import { render, staticRenderFns } from "./TheGroupModalLeave.vue?vue&type=template&id=3794d6a0&scoped=true"
import script from "./TheGroupModalLeave.vue?vue&type=script&lang=js"
export * from "./TheGroupModalLeave.vue?vue&type=script&lang=js"
import style0 from "./TheGroupModalLeave.vue?vue&type=style&index=0&id=3794d6a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3794d6a0",
  null
  
)

export default component.exports